import React from "react";
import PropTypes from "prop-types";
import { makeStyles, useTheme } from "@material-ui/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import { Page, PageContent, PageHeader } from "frame/components";
import { useRouter, useCurrentRole } from "utils";
import { ChildRoutes } from "./account-routes";
import * as fromRoutes from "../actions/types";
import { getTabConfig } from "../config";

const useStyles = makeStyles((theme) => ({
	root: {},
	headerTight: {
		// Reduce bottom space under the grey header to bring panel closer
		paddingBottom: `${theme.spacing(1)} !important`,
	},
}));

const Account = ({ role }) => {
	const classes = useStyles();
	const currentRole = useCurrentRole();
	const theme = useTheme();
	const mobileView = useMediaQuery(theme.breakpoints.down("xs"));

	const { match } = useRouter();
	const { tabId } = match.params;

	const config = getTabConfig(tabId, currentRole);

	return (
		<Page className={classes.root} title={config.label}>
			<PageHeader className={classes.headerTight} title={config.label} />
			<PageContent padSides padBottom>
				{mobileView && <br />}
				<ChildRoutes />
			</PageContent>
		</Page>
	);
};

Account.propTypes = {
	role: PropTypes.string.isRequired,
};

export default Account;
